<template>
  <header class="header" :class="headerClass" v-scroll="handleScroll" id="header" @click="closeSearch">
    <div class="header__inner">
      <burger />
      <header-search />
      <header-logo />
      <header-link />
    </div>
  </header>
</template>

<script setup lang="ts">
  import { useMainStore } from '@/stores/main';

  // Alternative: Use resolveComponent for explicit component resolution
  const Burger = resolveComponent('Burger');
  const HeaderSearch = resolveComponent('HeaderSearch');
  const HeaderLogo = resolveComponent('HeaderLogo');
  const HeaderLink = resolveComponent('HeaderLink');

  // Components are auto-imported by Nuxt
  // burger, header-search, header-logo, header-link are available globally

  const mainStore = useMainStore();
  const headerClass = ref('');
  const lastScrollTop = ref(0);

  function handleScroll(event: Event, el: HTMLElement) {
    // If using tabChangeState in store, port as needed
    if (mainStore.tabChangeState) return;
    if ((window.scrollY || window.pageYOffset) > 1) {
      if (lastScrollTop.value == (window.scrollY || window.pageYOffset)) return;
      headerClass.value = 'header_sticky';
      if ((window.scrollY || window.pageYOffset) > lastScrollTop.value) {
        headerClass.value = 'header_sticky';
      } else {
        headerClass.value = 'header_sticky header_sticky-show';
      }
      lastScrollTop.value = window.scrollY || window.pageYOffset;
    } else {
      headerClass.value = '';
    }
  }

  function closeSearch() {
    mainStore.setSearchFieldState(0);
  }
</script>
